import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export function BurgerIcon() {
	return (
  <svg
    viewBox="0 0 30 30"
    width="22"
    height="22"
    display="block"
    fill="inherit"
    flex-shrink="0"
    backface-visibility="hidden"
  >
    <path d="M2,4v2h26V4H2z M2,16h26v-2H2V16z M2,26h26v-2H2V26z" />
  </svg>
	);
}